/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_W2Inputs */

const en_mk_cmp_linear_w2 = /** @type {(inputs: Mk_Cmp_Linear_W2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need deep GitHub, Figma and Sentry integration today.`)
};

const id_mk_cmp_linear_w2 = /** @type {(inputs: Mk_Cmp_Linear_W2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda butuh integrasi dalam ke GitHub, Figma, dan Sentry hari ini juga.`)
};

/**
* | output |
* | --- |
* | "You need deep GitHub, Figma and Sentry integration today." |
*
* @param {Mk_Cmp_Linear_W2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_w2 = /** @type {((inputs?: Mk_Cmp_Linear_W2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_W2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_w2(inputs)
	return en_mk_cmp_linear_w2(inputs)
});